// extracted by mini-css-extract-plugin
module.exports = {"container":"notification_link-module__container--L6-Eh"};